import React, { useEffect, useMemo, useState, useRef } from 'react';
// import arrowClose from 'assets/images/arrow-close.svg';
// import arrowOpen from 'assets/images/arrow-open.svg';
import { Typography, Button, Row, Col, Select } from 'antd';
import { isLocaleEnglish } from 'utils';
import { HistoryCard } from './components/historyCard';
import styled from 'styled-components';
// import FPS from '@assets/images/FPS.svg';
// import { CommonSelectPicker } from './components/commonSelectPicker';
// import { HistoryPicker } from './components/historyPicker';
import { useLifePaymentReceiveDate, useLifePaymentHistorySearch, useGetHistoryRequest } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { useTranslation } from 'react-i18next';
import { changeDataFun } from 'utils';
import { Spinner } from 'components';
import './styles.less';
export const ResponsiveContainer = styled.div`
  width: 640px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const ResponsiveButton = styled(Button)`
  width: 426px;
  height: 56px;
  margin-left: 10px;
  margin-right: 10px;
  color: #c21b17;
  border: 1px solid #c21b17;
  font-family: 'Roboto500';
  font-size: 17px;

  @media (max-width: 576px) {
    width: 90%;
  }
`;
// import { QuickAction, ClaimInProgress, Shortfall } from 'src/screens/claims/components';
const { Text } = Typography;
interface historylistProps {
  productCategoryEn: string;
  productCategoryTC: string;
  productName: string;
  productNameTc: string;
  insuredName: string;
  policyNumber: string;
  receivedDate: string;
  paymentAmount: string;
  paymentMethodDesc: string;
  paymentMethodDescTc: string;
  paymentIcon: string;
}
export const PaymentHistory = (props: { policyNumber?: string }) => {
  const { i18n } = useTranslation();
  // const [loadingCount, setLoadingCount] = useState(0);
  const { token, ready } = useKeycloakReady();
  const [policyNumber, setPolicyNumber] = useState(props.policyNumber);
  const [companyCode, setCompanycode] = useState('');
  const [year, setYear] = useState('all' as string | undefined);
  interface DateType {
    paymentReceivedDate: string;
    selectYear: { label: string; value: string; code?: string }[];
  }
  const divRef = useRef<HTMLDivElement>(null);
  const [Date, setDate] = useState<DateType | null>(null);
  const [dropDataList, setDropDataList] = useState([] as { label: string; value: string; code: string }[]);
  // const [proName, setProName] = useState({ productName: '', productNameTC: '' });
  const { t } = useTranslation();
  const [randoms, setRandoms] = useState(0);
  const [viewMore, setViewMore] = useState({
    page: 0,
    pageSize: 5,
  });
  const [clickMore, setClickMore] = useState(false);
  const [moreExist, setMoreExist] = useState(true);
  const [historyList, setHistoryList] = useState<historylistProps[]>([]);
  const clickMoreRef = useRef(clickMore);
  const historyListRef = useRef(historyList);
  const languageRef = useRef(i18n.language);
  const [loading, setLoading] = useState(false);
  const [noPolicy, setNoPolicy] = useState(false);
  const { shouldFetch, data } = useLifePaymentReceiveDate(
    { name: 'useLifePaymentReceiveDate', params: { policyNumber, companyCode } },
    token || '',
    policyNumber || '',
    companyCode || '',
  );
  const {
    shouldFetch: shouldFetchDrop,
    data: dropData,
    // isLoading: dropDownLoading,
  } = useGetHistoryRequest('useGetHistoryRequest', token || '', {
    // onSuccess: () => {
    //    setLoading(false);
    // },
    onError: () => {
      setLoading(false);
      // setDropDataList([]);
      setNoPolicy(true);
    },
  });
  const {
    shouldFetch: shouldFetchhistoryData,
    data: historyData,
    error,
    // isLoading: historyDataLoading,
  } = useLifePaymentHistorySearch(
    {
      name: 'useLifePaymentHistorySearch' + randoms,
      params: {
        policyNumber,
        year,
      },
    },
    token || '',
    policyNumber || '',
    viewMore.page,
    viewMore.pageSize,
    year == 'all' ? '' : year,
    {
      shouldRetryOnError: false,
      revalidateOnFocus: false,
      // onSuccess: () => {
      //   setLoading(false);
      // },
      onError: () => {
        setLoading(false);
        setHistoryList([]);
      },
    },
  );
  React.useEffect(() => {
    setRandoms(Math.random());
  }, []);
  useEffect(() => {
    if (ready) {
      setRandoms(Math.random());
      // shouldFetch(ready);
      shouldFetchDrop(ready);
    }
    setLoading(true);
    //不放在初始化裏，暫時放在這，需要先獲取policyNo
  }, [token, ready, shouldFetchDrop, shouldFetch]);

  useEffect(() => {
    if (!dropData || dropData.length === 0) return;

    // console.log('1111111111111111111111111111');
    console.log('dropData', dropData);

    // 设置 policyNumber
    setPolicyNumber(props.policyNumber ?? dropData[0].policyNumber);

    const company = dropData.find((i) => i.policyNumber === (props.policyNumber ?? dropData[0].policyNumber));
    if (company) {
      // console.log('111111111111111111111111111111111111111111', company, policyNumber, token);
      setCompanycode(company.companyCode);
    }

    // console.log('props.policyNumber', props.policyNumber);

    // 设置 policyNumberLabel
    // if (props.policyNumber) {
    //   // const name = dropData?.find((item) => item.policyNumber === props.policyNumber);
    //   // if (name) {
    //   //   setPolicyNumberLabel(i18n.language === 'en' ? name.productName : name.productNameTC);
    //   // }
    // } else {
    //   setPolicyNumberLabel(i18n.language === 'en' ? dropData[0].productName : dropData[0].productNameTC);
    // }
    shouldFetch(true);
    shouldFetchhistoryData(true);
    const dropDownList = dropData.map((item) => {
      return {
        label: i18n.language == 'en' ? item.productName : item.productNameTC,
        value: item.policyNumber,
        code: item.companyCode,
      };
    });
    setDropDataList(dropDownList);
  }, [dropData, props.policyNumber, i18n, shouldFetchhistoryData, shouldFetch]);

  const dropDownList = useMemo(() => {
    if (!dropData) return [];
    return dropData?.map((item) => ({
      label: i18n.language === 'en' ? item.productName : item.productNameTC,
      value: item.policyNumber,
      code: item.companyCode,
    }));
  }, [dropData, i18n.language]); // 只有 dropData 或 i18n.language 变化时才重新计算

  useEffect(() => {
    setDropDataList(dropDownList);
  }, [dropDownList]); // 监听 dropDownList 的变化

  useEffect(() => {
    if (policyNumber) {
      shouldFetchhistoryData(true);
    }
  }, [policyNumber, shouldFetchhistoryData]);
  // dropData------------------------ Array [
  //   Object {
  //     "companyCode": "2",
  //     "policyNumber": "83000008",
  //     "productName": "Concord Life Insurance Plan",
  //     "productNameTC": "Concord Life Insurance Pla",
  //   },
  // ]
  useEffect(() => {
    if (!data) return;
    // shouldFetch(false);

    const selectYear = [
      { label: isLocaleEnglish(i18n.language) ? 'All' : '全選', value: 'all' },
      ...(Array.isArray(data.selectYear)
        ? data.selectYear.map((item) => ({
            label: item,
            value: item,
          }))
        : []), // Ensure it's always an array
    ];

    console.log('selectYear', selectYear, 'paymentreceiveddate', data.paymentReceivedDate);
    setDate({ paymentReceivedDate: data.paymentReceivedDate, selectYear: selectYear });
  }, [data, i18n, shouldFetch]);

  useEffect(() => {
    historyListRef.current = historyList;
    languageRef.current = i18n.language;
  }, [historyList, i18n.language]);
  useEffect(() => {
    clickMoreRef.current = clickMore; // Sync the ref with the state
  }, [clickMore]);
  useEffect(() => {
    if (!historyData) return;
    setLoading(false);
    const fetchPaymentIcons = async () => {
      const localClickMore = clickMoreRef.current; // Use the ref value here

      if (historyData && localClickMore) {
        setClickMore(false); // 这里更新 clickMore
        const updatedList = await Promise.all(
          historyData.paymentHistory?.map(async (item) => {
            if (item.paymentMethodUrl) {
              try {
                item.paymentMethodUrl = await (await fetch(item.paymentMethodUrl)).text();
              } catch (error) {
                console.error('Error fetching data:', error);
                item.paymentMethodUrl = ''; // 或者设置一个默认值
              }
            }

            return {
              productCategoryEn: historyData?.productCategoryEn,
              productCategoryTC: historyData?.productCategoryTC,
              productName: historyData?.productName,
              productNameTc: historyData?.productNameTc,
              insuredName: historyData?.insuredName,
              policyNumber: historyData?.policyNumber,
              receivedDate: item.receivedDate,
              paymentAmount:
                (isLocaleEnglish(languageRef.current) ? item.paymentCurrencyDesc : item.paymentCurrencyDescTc) +
                item.paymentAmount,
              paymentMethodDesc: item.paymentMethodDesc,
              paymentMethodDescTc: item.paymentMethodDescTc,
              paymentIcon: item.paymentMethodUrl,
            };
          }),
        );
        setHistoryList(historyListRef.current.concat(updatedList));
      } else if (historyData && !localClickMore) {
        setClickMore(false);
        const updatedList = await Promise.all(
          historyData.paymentHistory?.map(async (item) => {
            if (item.paymentMethodUrl) {
              try {
                item.paymentMethodUrl = await (await fetch(item.paymentMethodUrl)).text();
              } catch (error) {
                console.error('Error fetching data:', error);
                item.paymentMethodUrl = ''; // 或者设置一个默认值
              }
            }
            return {
              productCategoryEn: historyData?.productCategoryEn,
              productCategoryTC: historyData?.productCategoryTC,
              productName: historyData?.productName,
              productNameTc: historyData?.productNameTc,
              insuredName: historyData?.insuredName,
              policyNumber: historyData?.policyNumber,
              receivedDate: item.receivedDate,
              paymentAmount:
                (isLocaleEnglish(languageRef.current) ? item.paymentCurrencyDesc : item.paymentCurrencyDescTc) +
                item.paymentAmount,
              paymentMethodDesc: item.paymentMethodDesc,
              paymentMethodDescTc: item.paymentMethodDescTc,
              paymentIcon: item.paymentMethodUrl,
            };
          }),
        );
        setHistoryList(updatedList);
      } else if (error) {
        setClickMore(false);
        setMoreExist(false);
      }
      // console.log('historyData?.paymentHistory?.length', historyData?.paymentHistory?.length);
      if (historyData?.paymentHistory?.length < 5) {
        setMoreExist(false);
      } else if (historyData?.paymentHistory?.length == 5) {
        setMoreExist(true);
      }
    };

    fetchPaymentIcons();
  }, [historyData, error]); // 不再监听 clickMore
  // if (!Date || !historyDataList) {
  //   return <></>;
  // }

  // const [expanded1, setExpanded1] = useState(false);

  // // const toggleExpand1 = () => {
  // //   setExpanded1((show) => !show);
  // // };
  // const [expanded2, setExpanded2] = useState(false);

  const divRef2 = useRef<HTMLDivElement>(null);

  // 模拟 onLayout，通过 ResizeObserver 获取元素的大小
  useEffect(() => {
    if (divRef2.current) {
      const observer = new ResizeObserver(() => {
        // 在这里处理布局变化
        console.log('Layout changed', divRef2.current?.getBoundingClientRect());
      });
      observer.observe(divRef2.current);

      return () => observer.disconnect();
    }
  }, []);
  // const toggleExpand2 = () => {
  //   setExpanded2((show) => !show);
  // };
  // const [policyNumberLabel, setPolicyNumberLabel] = useState('' as string | undefined);
  // const [yearLabel, setYearlabel] = useState(
  //   isLocaleEnglish(i18n.language) ? 'Select Year' : ('選擇年份' as string | undefined),
  // );
  // const [top, setTop] = useState(0);
  // const [top2, setTop2] = useState(0);

  const onChange = (selectedItemValue: string | undefined) => {
    console.log('Selected item:', selectedItemValue);
    setViewMore({
      page: 0,
      pageSize: 5,
    });
    // setExpanded1(false);
    // setExpanded2(false);

    // 确保 selectedItemValue 和 selectedItemLabel 都有值
    if (selectedItemValue && selectedItemValue !== policyNumber) {
      // setPolicyNumberLabel(selectedItemLabel);
      console.log('selectedItemValue != policyNumber----------------Selected item', selectedItemValue);

      setPolicyNumber(selectedItemValue);

      // 使用可选链来避免 undefined 错误
      const selectedItem = dropDataList?.find((i) => i.value == selectedItemValue);
      // console.log('selectedItem_________________________', selectedItem);
      if (selectedItem) {
        setCompanycode(selectedItem?.code);
      }

      setLoading(true);
      shouldFetchhistoryData(true);
    }
  };
  const onChangeYear = (selectedItemValue: string | undefined) => {
    console.log('Selected item:', selectedItemValue);
    // setExpanded2(false);
    setViewMore({
      page: 0,
      pageSize: 5,
    });
    if (selectedItemValue != year) {
      // setYearlabel(selectedItemLabel);
      setYear(selectedItemValue);
      setLoading(true);
      shouldFetchhistoryData(true);
    }
  };
  // 模拟 onLayout，通过 ResizeObserver 获取元素的大小
  useEffect(() => {
    if (divRef.current) {
      const observer = new ResizeObserver(() => {
        // 在这里处理布局变化
        console.log('Layout changed', divRef.current?.getBoundingClientRect());
      });
      observer.observe(divRef.current);

      return () => observer.disconnect();
    }
  }, []);

  // const onLayout1 = (event) => {
  //   const { height } = event.nativeEvent.layout;
  //   console.log(height);
  //   setTop(height); // 根据需要调整top的值，例如添加一个额外的偏移量
  // };
  // const onLayout2 = (event) => {
  //   const { height } = event.nativeEvent.layout;
  //   console.log(height);
  //   setTop2(height); // 根据需要调整top的值，例如添加一个额外的偏移量
  // };
  // const windowHeight = useWindowDimensions().height;

  return (
    <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
      <Col xs={24} md={24} style={{ display: 'contents' }}>
        <div
          style={{
            width: '640px',
            maxWidth: '100%',
            // backgroundColor: 'pink',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'flex-start',
          }}
        >
          {Date && (
            <Text
              style={{
                display: 'inline-block',
                textAlign: 'start',
                width: '640px',
                maxWidth: '100%',
                paddingBottom: 8,
                paddingLeft: 8,
                color: '#6F7072',
                fontFamily: 'Roboto400',
                fontSize: '17px',
              }}
            >
              {t('life.Payment.received', {
                Date:
                  i18n.language == 'en'
                    ? Date.paymentReceivedDate || ''
                    : changeDataFun(Date.paymentReceivedDate || ''),
              })}
              {/* {`Only payments received after ${Date.paymentReceivedDate} will be shown below .`} */}
            </Text>
          )}
          {Date && (
            // <div
            //   style={{
            //     zIndex: 1,
            //     // backgroundColor: 'white',
            //     width: '640px',
            //     maxWidth: '100%',
            //   }}
            // >
            //   <div
            //     ref={divRef2} // 使用 ref 获取该元素
            //     onClick={() => setExpanded2(!expanded2)}
            //     style={{ paddingBottom: 16 }}
            //   >
            //     {/* 使用 div 替代 TouchableWithoutFeedback，添加 onClick 事件处理 */}
            //     <div
            //     // 处理点击事件
            //     >
            //       <div
            //         style={{
            //           height: '54px',
            //           display: 'flex',
            //           alignItems: 'center',
            //           backgroundColor: 'white',
            //           padding: '12px 0 12px 12px',
            //           borderRadius: 8,
            //           boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // 添加阴影
            //         }}
            //       >
            //         <div style={{ flex: 1 }}>
            //           <Text
            //             style={{
            //               display: 'inline-block',
            //               textAlign: 'start',
            //               width: '70%',
            //               fontFamily: 'Roboto500',
            //               fontSize: '17px',
            //             }}
            //           >
            //             {yearLabel}
            //           </Text>
            //         </div>
            //         <img
            //           src={expanded2 ? arrowOpen : arrowClose}
            //           width="16"
            //           height="16"
            //           style={{ border: 'none', marginRight: 12 }}
            //         />
            //       </div>
            //     </div>

            //     {/* 如果 expanded2 为 true，显示 CommonSelectPicker */}
            //     {expanded2 && (
            //       <CommonSelectPicker
            //         onChange={onChangeYear}
            //         pickerItems={Date?.selectYear as { label: string; value: string; code: string }[]}
            //         labelName={isLocaleEnglish(i18n.language) ? `Year` : `年份`}
            //       />
            //     )}
            //   </div>
            // </div>
            <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 8 }]} className="history2">
              <Col xs={24} md={24} style={{ display: 'contents' }}>
                {dropDataList && dropDataList.length > 0 ? (
                  <Select
                    placeholder={t('life.MakeRequest.Allpolicies')}
                    defaultValue={props.policyNumber || dropDataList[0]?.value || ''}
                    className="policySelect3"
                    popupClassName="slectop3"
                    style={{
                      fontSize: '20px',
                      fontFamily: 'Roboto400',
                      marginBottom: '10px',
                      padding: '4px 0',
                      width: '640px',
                    }}
                    onChange={(selectedItemValue) => {
                      onChange(selectedItemValue);
                    }}
                  >
                    {dropDataList.map((item) => (
                      <Select.Option key={item.value} value={item.value}>
                        <div style={{ display: 'grid' }} className={item.value !== '' ? '' : 'textcenter'}>
                          <span>{item.label}</span>
                          {item.value !== '' && (
                            <span>
                              {t('life.enquiry.policyNo')}
                              {item.value}
                            </span>
                          )}
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                ) : (
                  <div></div>
                )}
              </Col>
            </Row>
          )}
          {/* <Spin spinning={loading}> */}
          <Row
            justify="center"
            gutter={[16, { xs: 8, sm: 8, lg: 8 }]}
            className="history2"
            style={{ marginBottom: 20 }}
          >
            <Col xs={24} md={24} style={{ display: 'contents' }}>
              {!noPolicy && (
                <Select
                  placeholder={i18n.language == 'en' ? 'Select Year' : '選擇年份'}
                  // defaultValue={''}
                  className="policySelect2"
                  popupClassName="slectop3"
                  // options={dropDataList}
                  style={{
                    fontSize: '20px',
                    fontFamily: 'Roboto400',
                    marginBottom: '10px',
                    padding: '4px 0',
                    width: '640px',
                  }}
                  options={Date?.selectYear as { label: string; value: string; code: string }[]}
                  onChange={(selectedItemValue) => {
                    onChangeYear(selectedItemValue);
                  }}
                >
                  {/* {dropDataList &&
              dropDataList.map((item) => (
                <Select.Option key={item.value} value={item.value}>
                  <div style={{ display: 'grid' }} className={item.value != '' ? '' : 'textcenter'}>
                    <span>{item.label}</span>
                    {item.value != '' && (
                      <span>
                        {t('life.enquiry.policyNo')}
                        {item.value}
                      </span>
                    )}
                  </div>
                </Select.Option>
              ))} */}
                </Select>
              )}
            </Col>

            {/* {historyList.map((item, index) => {
              return (
                // <Col xs={24} key={index} md={24} style={{ display: 'contents' }}>
                <HistoryCard key={index} data={item} />
                // </Col>
              );
            })} */}

            {/* <Col xs={24} md={24} style={{ display: 'contents' }}> */}
            {loading ? (
              <Spinner />
            ) : historyList && historyList.length > 0 ? (
              historyList.map((item, index) => {
                return (
                  <ResponsiveContainer key={index}>
                    <HistoryCard key={index} data={item} />
                  </ResponsiveContainer>
                );
              })
            ) : (
              <Text
                style={{
                  display: 'inline-block',
                  textAlign: 'start',
                  width: '640px',
                  maxWidth: '100%',
                  padding: 16,
                  fontFamily: 'Roboto400',
                  fontSize: '17px',
                }}
              >
                {t('life.Payment.nohistory')}
              </Text>
            )}
            {/* </Col> */}
          </Row>
          {moreExist && !noPolicy && (
            <ResponsiveButton
              size="large"
              onClick={() => {
                setViewMore({
                  ...viewMore,
                  page: viewMore.page + 1,
                });
                setRandoms(Math.random());
                setLoading(true);
                shouldFetchhistoryData(true);
                setClickMore(true);
              }}
              disabled={false}
            >
              {t('questions.viewMore')} {/* 显示按钮文本 */}
            </ResponsiveButton>
          )}
        </div>
      </Col>
    </Row>
  );
};
